<template>
  <div class="main-content max-width-container">
    <back-navigation-container v-if="showBackButton"></back-navigation-container>

    <div v-if="(!canInterractWithJob || !isPublishedJob) && isJobDetailsExist" class="columns">
      <div class="column is-12">
        <highlighted-text-block :text-classes="'paragraph'">
          {{ labels.canNotInteractWithJob }}
        </highlighted-text-block>
      </div>
    </div>

    <div class="columns">
      <div class="column is-8">
        <div v-if="!$mq.desktop">
          <div v-if="isReferralCreationPending" class="job-referral-check-message">
            <info-text-block>
              <span>{{ tokenPendingMsg }}</span>
            </info-text-block>
          </div>
          <referral-job-link-container v-if="showReferralJob"></referral-job-link-container>
        </div>
        <card-panel v-if="jobDetailsState.summary">
          <div slot="content">
            <div class="panel-header">
              <svg-icon height="16" width="16" name="check-icon"></svg-icon>
              <div v-translate class="heading-3">Summary</div>
            </div>
            <div class="bullet-list-container" v-html="jobDetailsState.summary"></div>
          </div>
        </card-panel>

        <card-panel v-if="jobDetailsState.description">
          <div slot="content">
            <div class="panel-header">
              <svg-icon height="16" width="16" name="cv" class="reversed"></svg-icon>
              <div v-translate class="heading-3">Job description</div>
            </div>
            <div class="bullet-list-container" v-html="jobDetailsState.description"></div>
          </div>
        </card-panel>
      </div>
      <div v-if="$mq.desktop" class="column is-4">
        <div v-if="profileLoadingState || jobLoadingState" class="loader"></div>
        <div v-else>
          <referral-job-link-container v-if="showReferralJob"></referral-job-link-container>
          <div v-if="isReferralCreationPending" class="job-referral-check-message">
            <info-text-block>
              <span>{{ tokenPendingMsg }}</span>
            </info-text-block>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import 'top20common/distribution/icons/check-icon';
import 'top20common/distribution/icons/buildings';
import 'top20common/distribution/icons/cv';

import {isEmpty} from 'lodash';
import CardPanel from 'top20common/components/card-panel/CardPanel';
import HighlightedTextBlock from 'top20common/components/text-blocks/HighlightedTextBlock';
import InfoTextBlock from 'top20common/components/text-blocks/InfoTextBlock';
import {mapGetters} from 'vuex';

import BackNavigationContainer from '@/common/BackNavigationContainer';
import ReferralJobLinkContainer from '@/pages/job/ReferralJobLinkContainer';

export default {
  props: {
    showBackButton: Boolean,
    jobApplied: Boolean
  },
  computed: {
    ...mapGetters([
      'jobDetailsState',
      'jobLoadingState',
      'profileLoadingState',
      'canInterractWithJob',
      'isPublishedJob',
      'referrerState',
      'isReferralCreationPending',
      'isEmployerUser'
    ]),
    labels() {
      return {
        canNotInteractWithJob: this.$gettext('This job is not accepting applications at this time.')
      };
    },
    isJobDetailsExist() {
      return !isEmpty(this.jobDetailsState);
    },
    showReferralJob() {
      return this.canInterractWithJob && this.isPublishedJob && !this.isEmployerUser;
    },
    isReferee() {
      return !isEmpty(this.referrerState);
    },
    tokenPendingMsg() {
      return this.$gettext('We are now checking if your application qualifies for a bronze token.');
    }
  },
  components: {
    CardPanel,
    ReferralJobLinkContainer,
    BackNavigationContainer,
    HighlightedTextBlock,
    InfoTextBlock
  }
};
</script>

<style lang="scss" scoped>
@import '~VariablesStyles';

.main-content {
  margin: 0 auto;
  padding: 40px 0 40px;

  .column > *:not(last-child) {
    margin-bottom: 40px;
  }

  /deep/ .back-navigation {
    padding: 0 12px 18px;
  }
}

.panel-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  .heading-3 {
    margin-left: 10px;
  }
}

/deep/ .content-card-panel {
  padding: 40px;
}

/deep/ .svg-icon {
  .stroke {
    stroke: var(--secondary);
  }
  .fill {
    fill: var(--white);
  }
  .color {
    color: var(--secondary);
  }

  &.reversed {
    .stroke {
      stroke: var(--white);
    }
    .fill {
      fill: var(--secondary);
    }
  }
}

/deep/ .content ul {
  margin-left: 15px;
}

.job-referral-check-message {
  margin: 0 0 30px;

  @media screen and (min-width: $tablet) {
    margin: 30px 0;
  }
}
</style>
